/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const setupIntentDataSchema = z.object({
	clientSecret: z.string(),
	publishableKey: z.string(),
})

export type SetupIntentDataSchema = z.infer<typeof setupIntentDataSchema>
